module.exports = __webpack_public_path__ + "media/images/setting/Icon7-02d04aaa64a8a3f1eb43becaf1f7547b.svg";